import {IsBoolean, IsString} from 'class-validator';

export class FileConfirmRequestDto {
  @IsString()
  key!: string;

  @IsBoolean()
  shouldModifyExistContacts!: boolean;
}
